export default __webpack_public_path__ + "static/media/conference-Icon.425ce46b.svg";